export default {
  siteName: "USFansSheet",
  navHome: "Home",
  navShoppingGuide: "Shopping Guide",
  navSpreadsheet: "Spreadsheet",
  navCategories: "Categories",
  navGuides: "Guides",
  navFAQ: "FAQ",
  ctaExplore: "Explore Spreadsheet",
  ctaBuyNow: "Buy It Now",
  ctaMainSite: "Visit Main Website",
  dropdownLabel: "Browse Categories",
  dropdownPlaceholder: "Choose a category…",
  footerTagline:
    "An independent resource hub for the USFans Spreadsheet — helping you discover finds, compare options and buy smarter.",
  footerQuickLinks: "Quick Links",
  footerCategories: "Categories",
  footerLegal: "Legal",
  footerHome: "Home",
  footerGuide: "USFans Spreadsheet Guide",
  footerAbout: "About",
  footerContact: "Contact",
  footerPrivacy: "Privacy Policy",
  footerDisclaimer: "Disclaimer",
  footerAffiliate: "Affiliate Disclosure",
  externalNote: "External links open in a new tab.",
  copyright: "USFansSheet. All rights reserved.",
  notFoundTitle: "Page Not Found",
  notFoundDesc: "The page you are looking for does not exist or has been moved. Head back to the homepage to keep exploring.",
  notFoundCta: "Back to Homepage",
  disclaimer:
    "USFansSheet is an independent informational resource and is not affiliated with, endorsed by, or the official website of USFans. All product links redirect to third-party websites.",
  categories: {
    shoes: "Shoes",
    hoodiesSweaters: "Hoodies / Sweaters",
    tShirts: "T-Shirts",
    jackets: "Jackets",
    pantsShorts: "Pants / Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear / Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    otherStuff: "Other Stuff",
  },
};